import styled from 'styled-components';
import { HomeMenuCardWrapper } from './components/HomeMenuCard/HomeMenuCardStyles';
import { white } from 'styles/Colors';

export const HomePageWrapper = styled.div`
  ${HomeMenuCardWrapper} {
    &.live-dashboard,
    &.scoreboard-only,
    &.data-capture,
    &.pitchcom-service {
      padding: 0px 0px 28px 29px;
      margin-top: 20px;
      color: ${white};
      font-family: Oswald;
      font-size: 30px;
      font-weight: 500;
      line-height: 1;
      text-transform: uppercase;
    }
  }
`;

export const CardTitle = styled.div`
  position: absolute;
  bottom: 24px;
  left: 32px;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
